import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
    const { blocCouleurFond, blocCouleurBordure, blocImageFondUrl, blocImageFondId, animCode } = attributes;

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = blocImageFondUrl 
        ? { 
            backgroundImage: `url(${blocImageFondUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondUrl: media.url, blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {blocImageFondUrl ? (
                                        <div>
                                            <img src={blocImageFondUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondUrl: '', blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_inner_block */}
                <div>
                    {/* id_inner_block_logo_1 */}
                    <div className="row">
                        <div className="col-12">
                            <img id="id_inner_block_logo_1" src="attribut_id_inner_block_logo_1_src" alt="Logo" />
                        </div>
                    </div>
                    {/* end-id_inner_block_logo_1 */}
                    {/* id_inner_block_titre_1 */}
                    <div className="col-12">
                        <h1 id="id_inner_block_titre_1">
attribut_id_inner_block_titre_1_texte
                        </h1>
                    </div>
                    {/* end-id_inner_block_titre_1 */}
                    {/* id_inner_block_titre_2 */}
                    <div className="col-12">
                        <h2 id="id_inner_block_titre_2">
attribut_id_inner_block_titre_2_texte
                        </h2>
                    </div>
                    {/* end-id_inner_block_titre_2 */}
                    {/* id_inner_block_paragraphe_1 */}
                    <div className="col-12">
                        <p id="id_inner_block_paragraphe_1">
attribut_id_inner_block_paragraphe_1_texte
                        </p>
                    </div>
                    {/* end-id_inner_block_paragraphe_1 */}
                    {/* id_inner_block_paragraphe_2 */}
                    <div className="col-12">
                        <p id="id_inner_block_paragraphe_2">
attribut_id_inner_block_paragraphe_2_texte
                        </p>
                    </div>
                    {/* end-id_inner_block_paragraphe_2 */}
                    <div className="row justify-content-center">
                        {/* id_inner_block_bouton_1 */}
                        <div className="col-12 col-md-auto">
                            <a href="attribut_id_inner_block_bouton_1_lien" id="id_inner_block_bouton_1" className="btn" role="button">
                                {/* id_inner_block_bouton_1_texte_1 */}
                                <span id="id_inner_block_bouton_1_texte_1">
attribut_id_inner_block_bouton_1_texte_1_texte
                                </span>
                                {/* end-id_inner_block_bouton_1_texte_1 */}
                            </a>
                        </div>
                        {/* end-id_inner_block_bouton_1 */}
                        {/* id_inner_block_bouton_2 */}
                        <div className="col-12 col-md-auto">
                            <a href="attribut_id_inner_block_bouton_2_lien" id="id_inner_block_bouton_2" className="btn" role="button">
                                {/* id_inner_block_bouton_2_texte_1 */}
                                <span id="id_inner_block_bouton_2_texte_1">
attribut_id_inner_block_bouton_2_texte_1_texte
                                </span>
                                {/* end-id_inner_block_bouton_2_texte_1 */}
                            </a>
                        </div>
                        {/* end-id_inner_block_bouton_2 */}
                    </div>
                </div>
                {/* end-id_inner_block */}
            </section>
        </>
    );
}